import { api } from './client'

export type GCalStatus = {
  app_configured: boolean
  connected: boolean
  account_email?: string | null
  calendar_id?: string | null
  scope?: string | null
  connected_at?: string | null
  last_sync_at?: string | null
  expires_at?: string | null
  error?: string
}

export type GCalEvent = {
  id: string | null
  title: string
  description: string | null
  location: string | null
  start: string | null
  end: string | null
  is_all_day: boolean
  html_link: string | null
  organizer: string | null
  calendar_id?: string
  calendar_name?: string
  calendar_color?: string | null
}

export type GCalCalendar = {
  id: string
  name: string
  color: string | null
  primary: boolean
}

export type GCalEventsResponse = {
  calendars?: GCalCalendar[]
  count: number
  events: GCalEvent[]
}

export async function getGCalStatus(): Promise<GCalStatus> {
  return api<GCalStatus>('/me/calendar')
}

export async function getGCalConnectUrl(): Promise<{ authorize_url: string; state: string }> {
  return api<{ authorize_url: string; state: string }>('/me/calendar/connect')
}

export async function disconnectGCal(): Promise<void> {
  return api<void>('/me/calendar', { method: 'DELETE' })
}

export async function getGCalEvents(daysAhead = 7): Promise<GCalEventsResponse> {
  return api<GCalEventsResponse>(`/me/calendar/events?days_ahead=${daysAhead}`)
}

export async function getGCalEventsRange(timeMin: string, timeMax: string): Promise<GCalEventsResponse> {
  const qs = new URLSearchParams({ time_min: timeMin, time_max: timeMax })
  return api<GCalEventsResponse>(`/me/calendar/events?${qs.toString()}`)
}
